import { render, staticRenderFns } from "./Empresa.vue?vue&type=template&id=0f6d491e&scoped=true&lang=pug&"
import script from "./Empresa.vue?vue&type=script&lang=js&"
export * from "./Empresa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6d491e",
  null
  
)

export default component.exports